// extracted by mini-css-extract-plugin
export default {"footer":"EditorLLMDialogFooter__footer--2GAyh","select_section":"EditorLLMDialogFooter__select_section--1pS7X"};